import React from "react";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import { Checkbox, TableHead, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";
import ShipmentRegion from "../../HOC/CustomComponents/ShipmentRegion";
import { FixedTableCell } from "../../HOC/CustomComponents/FixedTableCell";

const PREFIX = "ShipmentListDetails";

const classes = {
  shipmentTable_checkbox: `${PREFIX}-shipmentTable_checkbox`,
};

const StyledTableHead = styled(TableHead)(({ theme }) => ({
  [`& .${classes.shipmentTable_checkbox}`]: {
    zIndex: "100",
    backgroundColor: "#fff",
    position: "sticky",
    top: 0,
    left: 0,
  },
}));

export const collectionShipmentsCells = (shipmentDetails, type) => {
  const cellsByType = {
    DLVBY: (
      <>
        <FixedTableCell>{shipmentDetails?.status?.name}</FixedTableCell>
        <FixedTableCell>{shipmentDetails?.type.name}</FixedTableCell>
        <FixedTableCell>{shipmentDetails?.customer?.name}</FixedTableCell>
        <FixedTableCell>{shipmentDetails?.recipientName}</FixedTableCell>
        <ShipmentRegion
          pathname={`/admin/zone/${shipmentDetails?.recipientZone?.id}`}
          zone={shipmentDetails?.recipientZone?.name}
          subzone={shipmentDetails?.recipientSubzone?.name}
        />
        <FixedTableCell>{shipmentDetails?.deliveryType?.name}</FixedTableCell>
        <FixedTableCell>{shipmentDetails?.deliveredAmount}</FixedTableCell>
        <FixedTableCell>{shipmentDetails?.collectedFees}</FixedTableCell>
        <FixedTableCell>{shipmentDetails?.description}</FixedTableCell>
        <FixedTableCell>
          {shipmentDetails?.calculatePendingCollection}
        </FixedTableCell>
      </>
    ),
    CUSTM: (
      <>
        <FixedTableCell>{shipmentDetails?.status?.name}</FixedTableCell>
        <FixedTableCell>{shipmentDetails?.type.name}</FixedTableCell>
        <FixedTableCell>{shipmentDetails?.recipientName}</FixedTableCell>
        <ShipmentRegion
          pathname={`/admin/zone/${shipmentDetails?.recipientZone?.id}`}
          zone={shipmentDetails?.recipientZone?.name}
          subzone={shipmentDetails?.recipientSubzone?.name}
        />
        <FixedTableCell>{shipmentDetails?.description}</FixedTableCell>
        <FixedTableCell>
          {shipmentDetails?.calculatePendingCollection}
        </FixedTableCell>
      </>
    ),
  };

  return cellsByType[type];
};

export function EnhancedTableHead(props) {
  const { onSelectAllClick, numSelected, rowCount, type } = props;
  const { t } = useTranslation();

  const headCells = {
    DLVBY: [
      t("requestCode"),
      t("shipmentStatus"),
      t("shipmentType"),
      t("customer"),
      t("recipient"),
      t("destination"),
      t("deliveryType"),
      t("deliveredAmount"),
      t("collectedFees"),
      t("description"),
      t("collectedAmount"),
    ],
    CUSTM: [
      t("requestCode"),
      t("shipmentStatus"),
      t("shipmentType"),
      t("recipient"),
      t("destination"),
      t("description"),
      t("collectedAmount"),
    ],
  };

  return (
    <StyledTableHead>
      <TableRow>
        <FixedTableCell
          className={classes.shipmentTable_checkbox}
          padding="checkbox"
        >
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ "aria-label": "select all desserts" }}
          />
        </FixedTableCell>
        {headCells[type].map((headCell, index) => (
          <FixedTableCell
            key={index}
            // align={headCell.numeric ? 'right' : 'left'}
          >
            {headCell}
          </FixedTableCell>
        ))}
      </TableRow>
    </StyledTableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  rowCount: PropTypes.number.isRequired,
};
